import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Input, Space, Tag } from "antd";
import { context } from "../../context/context";

const FeedBackFormStepTwo = () => {
    const [form] = Form.useForm();
    // state
    const [isEditSelected, setIsEditSelected] = useState(false);
    // const [data, setFeedBackData] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [answer, setAnswer] = useState();
    // context
    const {
        selectedFeedBackId,
        setFeedBackAnswers,
        setFeedBackQuestionText,
        feedBackQuestionText,
        feedBackAnswers,
        setFeedBackData,
        feedBackData,
    } = useContext(context);
    // useEffect
    useEffect(() => {
        if (selectedFeedBackId) {
            // http.get(`${config.parkopoloApi}/api/Event/${selectedEventId}`)
            //     .then((res) => {
            //         setEventLinks(res.data.result.links);
            //         setEventTitle(res.data.result.title);
            //         setEventTags(res.data.result.tags);
            //         setTextEditorHTML(res.data.result.data);
            //         setEventCover([res.data.result.coverPic]);
            //         setEventMedia(res.data.result.media);
            //         setEventStartDate(res.data.result.date.start);
            //         setEventEndDate(res.data.result.date.end);
            //         setDateRange([
            //             res.data.result.date.start,
            //             res.data.result.date.end,
            //         ]);
            //     })
            //     .catch((err) => {
            //         console.log(err);
            //     });
            setIsEditSelected(true);
        }
    }, []);

    // functions
    const handleQuestionChange = (e) => {
        setFeedBackQuestionText(e.target.value);
    };
    const handleAnswerChange = (e) => {
        setAnswer(e.target.value);
    };
    const handleAddQuestion = () => {
        setFeedBackData([
            ...feedBackData,
            { question: feedBackQuestionText, answers: feedBackAnswers },
        ]);
        setFeedBackQuestionText(null);
        setAnswers([]);
        setFeedBackAnswers([]);
    };
    const handleAddAnswer = () => {
        setFeedBackAnswers([...feedBackAnswers, { answer: answer }]);
        setAnswers([...answers, answer]);
        setAnswer(null);
    };
    const handleDeleteQuestion = (question) => {
        const filteredData = feedBackData.filter(
            (item) => item.question !== question
        );
        setFeedBackData(filteredData);
    };
    const handleDeleteAnswer = (id) => {
        const filteredAnswers = answers.filter((answer) => answer !== id);
        const filteredData = feedBackAnswers.filter(
            (item) => item.answer !== id
        );
        setFeedBackAnswers(filteredData);
        setAnswers(filteredAnswers);
    };
    return (
        <div
            style={{
                direction: "rtl",
                display: "flex",
                gap: "15px",
                margin: "15px",
            }}
        >
            <Form
                layout="vertical"
                form={form}
                name="control-hooks"
                style={{
                    width: "100%",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        gap: "30px",
                        alignItems: "center",
                    }}
                >
                    <Form.Item
                        name="متن سوال"
                        label="متن سوال"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ display: "none" }}>
                            {feedBackQuestionText}
                        </h4>
                        <Input
                            value={feedBackQuestionText}
                            onChange={handleQuestionChange}
                            placeholder="متن سوال را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item
                        name="متن گزینه"
                        label="متن گزینه"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ display: "none" }}>{answer}</h4>
                        <Input
                            value={answer}
                            onChange={handleAnswerChange}
                            placeholder="متن گزینه را وارد کنید"
                        />
                    </Form.Item>
                    <Button onClick={handleAddAnswer} disabled={!answer}>
                        اضافه کردن گزینه
                    </Button>
                    <Button
                        onClick={handleAddQuestion}
                        disabled={
                            feedBackAnswers.length === 0 ||
                            !feedBackQuestionText
                        }
                    >
                        اضافه کردن سوال و گزینه ها
                    </Button>
                </div>
                <Space wrap>
                    {answers.map((answer) => {
                        return (
                            <Tag
                                key={answer}
                                closeIcon
                                onClose={() => handleDeleteAnswer(answer)}
                                color="green"
                            >
                                {answer}
                            </Tag>
                        );
                    })}
                </Space>
                <div style={{ marginTop: "2rem" }}>
                    {feedBackData.map((item) => {
                        return (
                            <Tag
                                color="orange"
                                key={item.question}
                                closeIcon
                                onClose={() =>
                                    handleDeleteQuestion(item.question)
                                }
                            >
                                {item.question}
                            </Tag>
                        );
                    })}
                </div>
            </Form>
        </div>
    );
};

export default FeedBackFormStepTwo;
